import Immerable from '@naruto/naruto-reducers/src/types/GeneralImmer';

class Global extends Immerable {
  public globalLoading: boolean;

  public globalLang: string;

  public globalSideBar: boolean;

  public globalSideBarStatic: boolean;

  public globalHeader: boolean;

  public globalThemeVersion: string;

  public globalHistories: string[];

  public globalRoleSelect: boolean;

  public globalFontScale: number;

  public constructor() {
    super();
    this.globalLoading = false;
    this.globalSideBar = false;
    this.globalSideBarStatic = true;
    this.globalHeader = false;
    this.globalLang = '';
    this.globalThemeVersion = '';
    this.globalHistories = [];
    this.globalRoleSelect = false;
    this.globalFontScale = 1;
  }

  public initialize(): void {
    this.globalLoading = false;
    this.globalSideBar = false;
    this.globalSideBarStatic = true;
    this.globalHeader = false;
    this.globalRoleSelect = false;
    this.globalFontScale = 1;
  }

  public updateGlobalLoading(newGlobalLoading: boolean): void {
    this.globalLoading = newGlobalLoading;
  }

  public updateGlobalLang(newGlobalLang: string): void {
    this.globalLang = newGlobalLang;
  }

  public updateGlobalSideBar(newGlobalSideBarState: boolean): void {
    this.globalSideBar = newGlobalSideBarState;
  }

  public updateGlobalSideBarStatic(newGlobalSideBarStatic: boolean): void {
    this.globalSideBarStatic = newGlobalSideBarStatic;
  }

  public updateGlobalHeader(newGlobalHeader: boolean): void {
    this.globalHeader = newGlobalHeader;
  }

  public updateGlobalThemeVersion(version: string): void {
    this.globalThemeVersion = version;
  }

  public updateGlobalHistories(histories: string[]): void {
    this.globalHistories = histories;
  }

  public updateGlobalRoleSelect(newGlobalRoleSelect: boolean): void {
    this.globalRoleSelect = newGlobalRoleSelect;
  }

  public updateGlobalFontScale(newGlobalFontScale: number): void {
    this.globalFontScale = newGlobalFontScale;
  }
}

export default Global;
